import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    checkScroll:''    //监听距离

  },
  mutations:{
    monitorScroll(state,msg){
      state.checkScroll = msg
    },
    
  }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js